import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { Checkbox } from '@els/els-react--checkbox';
import { TogglePanel } from '@els/els-react--toggle-panel';
import { commaFormatNumber } from '@Utils/String';
import HtmlStripsService from '@Services/HtmlStripsService';

function ActiveChunk({ activeChunk, onCheckboxClick, isAuthorsOfSciDocFilter }) {
  return (
    <div className="new-author-checkboxes-dialog__active-chunk-wrapper">
      <div className="new-author-checkboxes-dialog__active-chunk">
        {activeChunk.map((item) => {
          const title = HtmlStripsService.getTitleWithoutHtml(item.get('title'), 'stripexceptions');
          const id = item.get('id');
          const size = item.get('size');
          const selected = item.get('selected');
          const affiliation = item.get('affiliation');
          const synonyms = item.get('synonyms');

          return (
            <div key={id} className="new-author-checkboxes-dialog__active-chunk-bordered new-author-checkboxes-dialog__active-chunk-row">
              <Checkbox
                className="new-author-checkboxes-dialog__active-chunk-checkbox"
                checked={selected}
                shouldHideLabel
                onChange={() => {
                  onCheckboxClick(id, selected);
                }}
              />
              <div className="new-author-checkboxes-dialog__active-chunk-title">
                {isAuthorsOfSciDocFilter ? (
                  <>
                    <TogglePanel id={id} header={title} size="s" headerLevel="4" disabled={!synonyms || synonyms.size === 0}>
                      {synonyms &&
                        synonyms?.toArray().map((synonym, synonymIndex) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <div key={synonymIndex} className="new-author-checkboxes-dialog__active-chunk-synonym">
                            {synonym}
                          </div>
                        ))}
                      {!synonyms || synonyms.size === 0 ? (
                        <div className="new-author-checkboxes-dialog__active-chunk-synonyms" aria-hidden="true" />
                      ) : null}
                    </TogglePanel>
                    {affiliation && <div className="new-author-checkboxes-dialog__active-chunk-affiliation">{affiliation}</div>}
                  </>
                ) : (
                  <span>{title}</span>
                )}
              </div>
              <span className="new-author-checkboxes-dialog__active-chunk-size">{commaFormatNumber(size)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ActiveChunk.propTypes = {
  activeChunk: PropTypes.instanceOf(List),
  onCheckboxClick: PropTypes.func.isRequired,
  isAuthorsOfSciDocFilter: PropTypes.bool,
};

export default ActiveChunk;
